import { render } from "./EditPaymentView.vue?vue&type=template&id=b0a15e40&scoped=true"
import script from "./EditPaymentView.vue?vue&type=script&lang=js"
export * from "./EditPaymentView.vue?vue&type=script&lang=js"

import "./EditPaymentView.vue?vue&type=style&index=0&id=b0a15e40&scoped=true&lang=css"

import exportComponent from "/Users/kokleng/Documents/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a15e40"]])

export default __exports__